<template>
  <div class="row">
    <div id="searchMenu" :class="{scrolled: scrollPosition > 101}">
      <el-row :gutter="20">
        <el-col :span="12">
          <h2 style="margin-left:30px;padding-top:20px;">Search</h2>
        </el-col>
        <div v-if="this.$route.name === 'advancedSearch'">
          <el-col :span="6">
            <el-button type="warning" class="searchBtn" @click="clear()">Clear Options</el-button>
          </el-col>
          <el-col :span="6">
            <button  class="btn btn-primary searchBtn" @click="search()">Search</button>
          </el-col>
        </div>
        <div v-if="this.$route.name === 'results'">
          <el-col :span="12">
            <button  class="btn btn-primary searchBtn" @click="search()">Back to Options</button>
          </el-col>
        </div>
      </el-row>
      <hr>
      <el-alert v-if="alertTitle !== ''"
        :title="alertTitle"
        :type="alertType"
        :description="callInfo"
        :closable="false"
        show-icon>
      </el-alert>
    </div>
    <div id="seachContent" style="width:100%;">
      <router-view ref="routeView" :filter.sync="filter" class="col-xl-12 col-lg-12"></router-view>
    </div>
  </div>
</template>

<script>
import Filter from '@/components/utility/filter.js'
export default {
  name: 'advancedSearch',
  data () {
    return {
      filter: new Filter(),
      scrollPosition: window.scrollY,
      callInfo: '',
      alertType: '',
      alertTitle: ''
    }
  },
  mounted: function () {
    window.addEventListener('scroll', this.updateScroll)
  },
  methods: {
    updateScroll () {
      this.scrollPosition = window.scrollY
    },
    search () {
      this.callInfo = ''
      this.alertType = ''
      this.alertTitle = ''
      this.$refs.routeView.search()
    },
    clear () {
      this.filter = new Filter()
      this.$refs.routeView.updateFilter()
      this.callInfo = ''
      this.alertType = ''
      this.alertTitle = ''
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#searchMenu.scrolled {
  box-shadow: 0 5px 10px rgba(0,0,0,.5);
  position: fixed;
  margin-top: -140px;
  transform: translateZ(0);
  width: 97%;
}
#searchMenu.scrolled hr {
  width:99%;
}
#searchMenu {
  width: 100%;
  margin-top: -50px;
  background: white;
  z-index: 12;
  padding-left: 10px;
  padding-right: 10px;
}

.searchContent {
  padding-top: 50px;
  z-index: 1;
  width: 100%;
}

.searchBtn {
  float: right;
  margin-top: 20px;
}
</style>
